import React, { forwardRef} from 'react';
import { Stage, Layer, Rect } from 'react-konva';


const CellTemplate = forwardRef(({ width, height, children, backgroundColor = "white", borderColor, borderWidth = 0, borderRadius = 0 },ref) => {

  // Use a ref callback to disable pointer events on the Konva canvas element directly
  const containerRef = React.useCallback((node) => {
    if (node) {
      const canvas = node.querySelector('canvas');
      if (canvas) canvas.style.pointerEvents = 'none';
    }
  }, []);

  return (
    <div className="cell-template-canvas" ref={containerRef}>
    <Stage width={width} height={height} ref={ref} listening={false} >
      <Layer>
      <Rect
          id="template-background"
          width={width}
          height={height}
          fill={backgroundColor}
          cornerRadius={borderRadius}
          listening={false}
        />
        {borderWidth > 0 && borderColor && (
          <Rect
            width={width}
            height={height}
            stroke={borderColor}
            strokeWidth={borderWidth}
            cornerRadius={borderRadius}
            listening={false}
          />
        )}
      </Layer>
      <Layer>
        {children}
      </Layer>
    </Stage>
    </div>
  );
});

export default CellTemplate;